import React from 'react';
import { useTransition, animated } from 'react-spring/web.cjs';
import DSBreadcrumb from '@elliemae/ds-basic/Breadcrumb';
import { animationConfig } from '../animation/animationConfig.js';

/* eslint-disable react/prop-types */

function ShuttleBreadcrumb(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      _ref$hierarchy = _ref.hierarchy,
      hierarchy = _ref$hierarchy === void 0 ? [] : _ref$hierarchy,
      _ref$onNavigateTo = _ref.onNavigateTo,
      onNavigateTo = _ref$onNavigateTo === void 0 ? function () {
    return null;
  } : _ref$onNavigateTo;
  var animatedCrumbs = useTransition(hierarchy, function (item) {
    return item.id;
  }, animationConfig.breadcrumb());
  return /*#__PURE__*/React.createElement("div", {
    className: className
  }, /*#__PURE__*/React.createElement(DSBreadcrumb, {
    isTitle: true
  }, animatedCrumbs.map(function (_ref2) {
    var item = _ref2.item,
        props = _ref2.props,
        key = _ref2.key;
    return /*#__PURE__*/React.createElement(DSBreadcrumb.Item, {
      key: key,
      containerComponent: animated.li,
      label: item.name,
      onClick: function onClick() {
        return onNavigateTo(item, 'up');
      },
      style: props
    });
  })));
}

export default ShuttleBreadcrumb;
//# sourceMappingURL=ShuttleBreadcrumb.js.map
